import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
import { isEqual } from "lodash";
import sortObject from "functions/sort-object";
import SearchSelect from "components/common/SearchSelect";
import {
    fetchSuppliersList,
} from "api/menu/master-files/suppliers/actions";
import {
    fetchJobs,
    fetchJobBySupplierId,
    clearJobs
} from "api/menu/master-files/job-maintenance/actions";

class ListChargesHeader extends Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            ...this.props.filters,

            suppliersOptions: [],
            jobOptions: [],
        };

        this.props.fetchSuppliersList();
        this.props.fetchJobs(false);
        this.handleSupplierSelect = this.handleSupplierSelect.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const newState = {};
        if (!isEqual(nextProps.filters, this.props.filters)) {
            Object.keys(nextProps.filters).forEach(key => {
                newState[key] = nextProps.filters[key];
            });
        }

        if (!isEqual(nextProps.suppliers, this.props.suppliers)
            || !this.state.suppliersOptions.length) {
            newState.suppliersOptions = [];
            sortObject(
                nextProps.suppliers,
                Object.keys(nextProps.suppliers).map((value) => parseInt(value, 10)),
                "lastName",
                true
            ).forEach(index => {
                newState.suppliersOptions.push({
                    value: nextProps.suppliers[index].id,
                    label: nextProps.suppliers[index].name
                });
            });
        }

        if (!isEqual(nextProps.jobs, this.props.jobs)) {
            newState.jobOptions = nextProps.jobs.map(value => ({
                label: `${value.jobNumber} - ${value.description}`,
                value: value.id,
                supplierId: value.supplierId
            }));
        }

        if (Object.keys(newState).length) {
            this.setState(newState);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (!isEqual(nextProps.suppliers, this.props.suppliers)) {
            return true;
        } else if (!isEqual(nextProps.jobs, this.props.jobs)) {
            return true;
        } else if (!isEqual(nextProps.filters, this.props.filters)) {
            return true;
        } else if (!isEqual(nextProps.selectedChargesCount, this.props.selectedChargesCount)) {
            return true;
        }
        return false;
    }

    componentWillUnmount() {
        this.props.clearJobs();
    }

    handleSupplierSelect = (option) => {
        if (option !== null) {
            this.props.fetchJobBySupplierId(option.value);
        } else {
            this.props.fetchJobs(false);
        }

        this.props.handleSelect([{
            name: "supplierId",
            value: option
        }, {
            name: "jobId",
            value: null
        }]);
    };

    render() {
        // const { userRole } = this.props;
        const { selectedChargesCount } = this.props;
        const {
            fromDate,
            toDate,
            supplierId,
            suppliersOptions,
            jobId,
            jobOptions,
            hideMatchingReversals
        } = this.state;

        // const isAdminView = userRole.includes(UserTypes.admin);

        return (
            <div className="row pt-1 pb-3">

                <div className="col-2">
                    <div className="form-group mb-0">
                        <label className="d-block mb-0 font-weight-bold form-label">
                            Supplier
                        </label>
                        <SearchSelect
                            className="custom-react-select"
                            isLoading={false}
                            isClearable={true}
                            isSearchable={true}
                            options={suppliersOptions}
                            value={supplierId}
                            onChange={(option) => this.handleSupplierSelect(option)}
                        />
                    </div>
                    <div className="form-group mb-0">
                        <label className="d-block mb-0 font-weight-bold form-label">
                            Job
                        </label>
                        <SearchSelect
                            className="custom-react-select"
                            isLoading={false}
                            isClearable={true}
                            isSearchable={true}
                            options={jobOptions}
                            value={jobId}
                            onChange={option => {
                                const arr = [];
                                arr.push({
                                    name: "jobId",
                                    value: option
                                });
                                if (option) {
                                    arr.push({
                                        name: "supplierId",
                                        value: suppliersOptions
                                            .find(item => item.value === option.supplierId)
                                    });
                                }
                                this.props.handleSelect(arr);
                            }}
                        />
                    </div>
                </div>

                <div className="col-2">
                    <div className="form-group mb-0">
                        <label className="d-block mb-0 font-weight-bold form-label">
                            From Date
                        </label>
                        <DatePicker
                            value={fromDate}
                            format={this.dateFormat}
                            onChange={date => this.props.handleSelect([{
                                name: "fromDate",
                                value: date
                            }])}
                            className="d-block"
                            allowClear={false}
                        />
                    </div>
                    <div className="form-group mb-0">
                        <label className="d-block mb-0 font-weight-bold form-label">
                            To Date
                        </label>
                        <DatePicker
                            value={toDate}
                            format={this.dateFormat}
                            onChange={date => this.props.handleSelect([{
                                name: "toDate",
                                value: date
                            }])}
                            className="d-block"
                        />
                    </div>
                </div>

                <div className="col-2 d-flex flex-column justify-content-end">
                    <button
                        className="btn btn-primary"
                        onClick={() => this.props.handleLoad()}
                    >
                        Load
                    </button>
                    <button
                        className="btn btn-warning mt-4"
                        onClick={() => this.props.handleReset()}
                    >
                        Reset
                    </button>
                </div>

                <div className="col-2 mt-2">
                    <div className="custom-control custom-checkbox mt-4">
                        <input
                            id="hideMatchingReversals"
                            type="checkbox"
                            checked={hideMatchingReversals}
                            className="custom-control-input"
                            onChange={() => this.props.handleSelect([{
                                name: "hideMatchingReversals",
                                value: !hideMatchingReversals
                            }])}
                        />
                        <label
                            className="custom-control-label"
                            htmlFor="hideMatchingReversals"
                        >
                            Hide Matching Reversals
                        </label>
                    </div>
                </div>

                <div className="col-2 d-flex flex-column justify-content-end">
                    <button
                        className="btn btn-warning"
                        onClick={this.props.handleGeneratePreliminaryInvoice}
                        disabled={selectedChargesCount === 0}
                    >
                        Generate Preliminary Invoice
                    </button>
                    <button
                        className="btn btn-info mt-4"
                        onClick={this.props.handlePrintCharges}
                        disabled={selectedChargesCount === 0}
                    >
                        Export Charges
                    </button>
                </div>
            </div>
        );
    }
}

ListChargesHeader.propTypes = {
    handleLoad: PropTypes.func.isRequired,
    handleReset: PropTypes.func.isRequired,
    handleSelect: PropTypes.func.isRequired,

    handleGeneratePreliminaryInvoice: PropTypes.func.isRequired,
    selectedChargesCount: PropTypes.number.isRequired,
    handlePrintCharges: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    userRole: state.auth.user.role,
    jobs: state.jobs.jobs,

    suppliers: state.suppliers.suppliers,
});

const mapStateToDispatch = dispatch => ({
    fetchSuppliersList: bindActionCreators(fetchSuppliersList, dispatch),
    fetchJobs: bindActionCreators(fetchJobs, dispatch),
    fetchJobBySupplierId: bindActionCreators(fetchJobBySupplierId, dispatch),
    clearJobs: bindActionCreators(clearJobs, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ListChargesHeader);
